/* ===========================================================
   product-card.js
   -----------------------------------------------------------
   One delegated ATC handler for the unified .mkp-card markup
   rendered by snippets/product-card.liquid. Replaces the per-
   section handlers that previously lived inline in:
     - sections/grid-products-noimg.liquid  (.gpn-btn handler)
     - sections/home-collection-image.liquid (.sir-btn handler)
     - templates/collection.json custom_liquid (.gpn-btn copy)
     - templates/metaobject/brand_artist.json custom_liquid (.gpn-btn copy)
     - templates/product.json custom_liquid (.bc-btn handler)

   Behavior matches the prior per-section handlers exactly:
     - Click .mkp-card__atc[data-add-id]
     - POST /cart/add.js
     - On success: refresh header cart count + dispatch cart:updated event
     - Button text: ADD TO CART → Adding… → Added ✓ → ADD TO CART
     - On failure: Try again (then revert)

   Loaded once via layout/theme.liquid.
   =========================================================== */
(function () {
  'use strict';

  async function refreshHeaderCount() {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
      document.querySelectorAll('[data-header-cart-count]').forEach(el => {
        el.textContent = String(cart.item_count);
        if (cart.item_count > 0) {
          el.removeAttribute('aria-hidden');
        } else {
          el.setAttribute('aria-hidden', 'true');
        }
        el.hidden = false;
        const hiddenParent = el.closest('[hidden]');
        if (hiddenParent) hiddenParent.removeAttribute('hidden');
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (_) { /* swallow — UI already reflects the add via button state */ }
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.mkp-card__atc[data-add-id]');
    if (!btn) return;
    if (btn.disabled) return;

    const id = btn.getAttribute('data-add-id');
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 }),
        credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('Add failed');
      await res.json();
      await refreshHeaderCount();
      btn.textContent = 'Added ✓';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 900);
    } catch (_) {
      btn.textContent = 'Try again';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1200);
    }
  });
})();
